import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Divider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  appDarkBlue,
  FOOTER_HEIGHT,
  footerColor,
  navbarBlue,
  subTitleBlue,
} from "../../Classes/theme";

//import PaymentLogos from "../Base/PaymentLogos";
import LockIcon from "@mui/icons-material/Lock";
import { theme } from "../../App";
import { Motion } from "../Motion/Motion";
import CookieBar from "../Legal/CookieBar";
import { withRouter } from "../withRouter";
import FooterExtension from "./FooterExtension";
import AppIcon from "../Navbar/AppIcon";
import PaymentLogos from "./Pay/PaymentLogos";



const Lock = () => {
  const editedIcon = React.cloneElement(<LockIcon />, {
    style: {
      height: "12px",
      maxWidth: "12px",
      fill: "white",
    },
  });
  return <>{editedIcon}</>;
};

function BaseFooter({ extended = true }) {
  const [cookieOpen, setCookieOpen] = useState(false);
  const mobile = useMediaQuery(theme.breakpoints.only("xs"));
  const tablet = useMediaQuery(theme.breakpoints.down("md"));
  let navigate = useNavigate();

  return (
    <footer>
      {<CookieBar open={cookieOpen} setOpen={setCookieOpen} />}
      {!tablet && extended && <FooterExtension />}
      <Box
        sx={{
          width: "100%",
          height: `${FOOTER_HEIGHT}px`,
          bgcolor: footerColor,
          position: "static",
          bottom: 0,
          boxShadow: "0px -2px 5px 0px rgba(115,117,122,0.3)",

        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              width: "100%",
              height: "100%",
              p: "20px",
              pt: '25px',
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Box
                component={Link}
                sx={{
                  marginRight: "auto",
                  display: "flex",
                  justifyContent: "center",
                  textDecoration: "none",
                  width: "fit-content",
                  p: "5px",
                  pl: "0px",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}

                to="/"
              >
                <AppIcon textColor={'white'} />
              </Box>
              <Box sx={{ ml: "auto" }}>
                <Motion>
                  <Box
                    sx={{
                      width: "fit-content",
                      height: "22px",
                      bgcolor: navbarBlue,
                      display: "flex",
                      flexDirection: "row",
                      alignContent: "center",
                      alignItems: "center",
                      borderRadius: "12px",
                      p: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/cookies");
                    }}
                  >
                    <Lock />
                    {!mobile && (
                      <Typography
                        sx={{ mx: "15px", fontSize: "11px", mt: "1px", color: 'white' }}
                      >
                        Cookies policy
                      </Typography>
                    )}
                  </Box>
                </Motion>
              </Box>
            </Box>
            <Box
              sx={{
                mt: "30px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                  //display: { xs: "none", sm: "flex", md: "flex" },
                }}
              >
                <Typography

                  sx={{
                    fontWeight: "normal",
                    fontSize: "10px",
                    lineHeight: "15px",
                    textAlign: "left",
                    mr: "20px",
                    color: 'white'
                  }}
                >
                  {mobile ? (
                    <>© {new Date().getFullYear()} Metastream&nbsp;s.r.o</>
                  ) : (
                    `© ${new Date().getFullYear()} Metastream s.r.o | všechna práva
                vyhrazena | metastream@email.cz | Högrova 2862/2 | Královo
                Pole | 612 00 Brno | IČO: 08393494 | DIČ: CZ08393494`
                  )}
                </Typography>
              </Box>
              <Box sx={{ ml: "auto" }}>
                <PaymentLogos />
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </footer>
  );
}

export default withRouter(BaseFooter);
